<script setup lang="ts">
  const emit = defineEmits<{
    create: [];
  }>();

  const steps = [
    {
      icon: 'mdi-store-plus',
      title: 'Cree su tienda',
      description: 'Configure su información básica',
    },
    {
      icon: 'mdi-menu',
      title: 'Agregue su menú',
      description: 'Agregue categorías y productos',
    },
    {
      icon: 'mdi-qrcode',
      title: 'Genere su QR',
      description: 'Comparta su menú digital',
    },
  ];
</script>

<template>
  <div class="create-restaurant-empty">
    <div class="empty-content">
      <div class="empty-illustration">
        <v-icon class="illustration-icon">mdi-store</v-icon>
      </div>

      <h2 class="empty-title">¡Bienvenido a QueResto!</h2>

      <p class="empty-description">
        Cree su primera tienda digital y comience a recibir pedidos en minutos.
        Con QueResto, tendrá su menú digital con código QR completamente
        gratis.
      </p>

      <div class="steps-container">
        <div v-for="(step, index) in steps" :key="step.title" class="step-item">
          <div class="step-number">{{ index + 1 }}</div>
          <v-icon class="step-icon">{{ step.icon }}</v-icon>
          <div class="step-content">
            <h4 class="step-title">{{ step.title }}</h4>
            <p class="step-description">{{ step.description }}</p>
          </div>
        </div>
      </div>

      <v-btn
        color="primary"
        size="large"
        @click="$emit('create')"
        class="create-button"
      >
        <v-icon left>mdi-plus</v-icon>
        Crear mi primera tienda
      </v-btn>

      <div class="benefits">
        <div class="benefit-item">
          <v-icon class="benefit-icon" color="green">mdi-check-circle</v-icon>
          <span>Gratis de por vida</span>
        </div>
        <div class="benefit-item">
          <v-icon class="benefit-icon" color="green">mdi-check-circle</v-icon>
          <span>Sin comisiones</span>
        </div>
        <div class="benefit-item">
          <v-icon class="benefit-icon" color="green">mdi-check-circle</v-icon>
          <span>Configuración en 5 minutos</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .create-restaurant-empty {
    @apply tw-bg-white tw-rounded-3xl tw-shadow-sm;
    @apply tw-p-8 tw-text-center;
    @apply tw-w-full;

    .empty-content {
      @apply tw-space-y-6;

      .empty-illustration {
        @apply tw-mb-6;

        .illustration-icon {
          @apply tw-text-[120px] tw-text-neutral-300;
        }
      }

      .empty-title {
        @apply tw-text-3xl tw-font-light tw-text-neutral-800;
      }

      .empty-description {
        @apply tw-text-lg tw-text-neutral-600 tw-max-w-2xl tw-mx-auto;
      }

      .steps-container {
        @apply tw-grid tw-gap-4 tw-my-8;
        @apply sm:tw-grid-cols-3;

        .step-item {
          @apply tw-relative tw-p-4;
          @apply tw-bg-neutral-50 tw-rounded-xl;

          .step-number {
            @apply tw-absolute tw-top-2 tw-right-2;
            @apply tw-w-6 tw-h-6 tw-rounded-full;
            @apply tw-bg-orange-500 tw-text-white;
            @apply tw-flex tw-items-center tw-justify-center;
            @apply tw-text-xs tw-font-semibold;
          }

          .step-icon {
            @apply tw-text-3xl tw-text-orange-500 tw-mb-2;
          }

          .step-content {
            .step-title {
              @apply tw-text-base tw-font-medium tw-text-neutral-800 tw-mb-1;
            }

            .step-description {
              @apply tw-text-sm tw-text-neutral-600;
            }
          }
        }
      }

      .create-button {
        @apply tw-text-lg tw-px-8 tw-py-6;
        @apply tw-font-light;
      }

      .benefits {
        @apply tw-flex tw-flex-wrap tw-justify-center tw-gap-4;
        @apply tw-mt-8;

        .benefit-item {
          @apply tw-flex tw-items-center tw-gap-2;
          @apply tw-text-sm tw-text-neutral-600;

          .benefit-icon {
            @apply tw-text-lg;
          }
        }
      }
    }
  }

  // Mobile adjustments
  @media (max-width: 640px) {
    .create-restaurant-empty {
      @apply tw-p-6;

      .empty-content {
        .empty-illustration {
          .illustration-icon {
            @apply tw-text-[80px];
          }
        }

        .empty-title {
          @apply tw-text-2xl;
        }

        .empty-description {
          @apply tw-text-base;
        }

        .steps-container {
          @apply tw-grid-cols-1;
        }

        .benefits {
          @apply tw-flex-col;
        }
      }
    }
  }
</style>
